var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 24H8.99968L24 0H0V24Z",
    fill: "#9DCC3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9993 23.9997H9.1018L5.2793 17.6869L14.0536 7.67969L23.9993 23.9997Z",
    fill: "#67B240"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91088 5.75977H16.6477C16.9965 5.75977 17.2793 6.04256 17.2793 6.39134V17.1282C17.2793 17.477 16.9965 17.7598 16.6477 17.7598H5.91088C5.56209 17.7598 5.2793 17.477 5.2793 17.1282V6.39134C5.2793 6.04256 5.56209 5.75977 5.91088 5.75977Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2385 13.4531C12.2385 12.3057 8.19261 13.0231 8.19261 10.3915C8.19261 9.24979 9.41097 8.16016 11.2674 8.16016C13.2398 8.16016 14.1101 9.19788 14.1101 9.19788L13.1406 10.6178C13.0594 10.5161 12.9589 10.4136 12.8396 10.3106C12.8396 10.3106 12.3 9.82073 11.4994 9.82073C10.9774 9.82073 10.4574 10.0037 10.4574 10.4434C10.4574 11.4294 14.4002 10.9104 14.4002 13.4531C14.4002 14.7504 13.182 15.8402 11.1514 15.8402C9.59592 15.8402 8.59684 15.1861 8.16016 14.8259C8.16016 14.8259 8.48522 14.351 9.13519 13.4011C9.13519 13.4011 9.87513 14.1796 10.9194 14.1796C11.6585 14.1796 12.2385 13.9681 12.2385 13.4531Z",
    fill: "#67B240"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKse);
export default __webpack_public_path__ + "static/media/kse.ac4cce0b.svg";
export { ForwardRef as ReactComponent };